// extracted by mini-css-extract-plugin
export default {"container":"document_form_multiline_container__mZ9y2","input":"document_form_multiline_input__F86ly","tooltip":"document_form_multiline_tooltip__syOR9"};